module.exports = "/images/Icon-4.svg?1ed0da234677a41537ee37a0d7f9a070";